import register from '../register';

class TrustpilotReview {

  constructor( el ) {
    this.el = el;
    this.inner = this.el.querySelector('.inner');
    this.open = false;
    this.short = this.el.dataset.shortText ? this.el.dataset.shortText : null;
    this.full = this.el.dataset.fullText ? this.el.dataset.fullText : null;
    this.trigger = this.el.querySelector('.show-more');
    this.toggle = this.toggle.bind( this );
    this.bindEvents();
  }

  bindEvents() {
    if ( this.trigger ) {
      this.trigger.addEventListener( 'click', this.toggle );
    }
  }

  toggle( e ) {
    e.preventDefault();
    this.open = !this.open;
    this.inner.innerText = this.open ? this.full : this.short;
    this.trigger.innerText = this.open ? 'Show Less' : 'Show More';
  }

}

register( 'trustpilot-reviews', () => {
  const reviews = document.querySelectorAll('.review__text');
  reviews.forEach( review => new TrustpilotReview( review ) );
});

export default undefined;
